import { render, staticRenderFns } from "./MyWorkAssignmentSelector.vue?vue&type=template&id=473d205c&"
import script from "./MyWorkAssignmentSelector.vue?vue&type=script&lang=js&"
export * from "./MyWorkAssignmentSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports